import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DataProductsService } from 'src/app/views/data-products/data-products.service';


@Component({
    selector: 'app-dataset-detail-modal',
    templateUrl: './dataset-detail-modal.component.html',
    styleUrls: ['./dataset-detail-modal.component.scss'],
})
export class DatasetDetailModalComponent implements OnInit {
    @Output() closed = new EventEmitter<void>();
    @Input() dataset: any = null;
    data: any[] = [];

    constructor(
        private dataProductsService: DataProductsService,
    ) {}

    async ngOnInit() {
        if (this.dataset?.id == null) return;
        const res: any = await firstValueFrom(this.dataProductsService.getFieldList({ datasetId: this.dataset.id }));
        if (res?.status && res?.data) {
            this.data = res.data ?? [];
        }
    }

    close() {
        this.closed.emit();
    }

}
